import React from 'react';
import { EyeIcon, StarIcon, ArrowRightIcon } from 'lucide-react';
import { Header } from './Header';
import { Footer } from './Footer';
import { ComparisonTable } from './ComparisonTable';
import { Testimonial } from './Testimonial';
import { CTAButton } from './CTAButton';
import { StickyCTA } from './StickyCTA';
import { UrgencyBanner } from './UrgencyBanner';
import { ImageSection } from './ImageSection';
import { useLocation } from '../hooks/useLocation';
export const Advertorial = () => {
  const {
    city,
    isLoading
  } = useLocation();
  const localizeText = (text: string): string => {
    if (isLoading) return text;
    return text.replace(/New York/g, city).replace(/NEW YORK/g, city.toUpperCase()).replace(/new york/g, city.toLowerCase());
  };
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-6">
      <Header data-id="element-7" />
      <div className="w-full bg-gray-50" data-id="element-8">
        <div className="text-xs font-semibold text-gray-500 py-2 text-center border-b border-gray-200" data-id="element-9">
          WOMEN'S HEALTH | Advertorial
        </div>

        <UrgencyBanner data-id="element-10" />

        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 sm:py-6 bg-white" data-id="element-11">
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-8" data-id="element-12">
            <main className="flex-grow w-full lg:w-2/3" data-id="element-13">
              {/* Main headline */}
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-14">
                {localizeText('(City) Lipedema Specialists Reveal: The Hidden Reason Compression Stockings Rarely Work for Lipedema (And What to Try Instead)').replace('(City)', city)}
              </h1>

              {/* Subheadline */}
              <p className="text-base md:text-lg text-gray-700 mb-4 sm:mb-6" data-id="element-15">
                Up to 17 million women in the US have lipedema.{' '}
                {localizeText('New York')} specialists say a new type of
                compression is finally helping them find relief.
              </p>

              {/* Author byline */}
              <div className="flex items-center justify-between text-sm text-gray-600 mb-4 sm:mb-6 border-b border-gray-200 pb-3 sm:pb-4" data-id="element-16">
                <span className="text-xs sm:text-sm" data-id="element-17">
                  By Jennifer Martinez, Women's Health | April 29, 2025
                </span>
                <span className="flex items-center text-xs sm:text-sm" data-id="element-18">
                  <span data-id="element-19">312,847</span>
                  <EyeIcon className="h-3 w-3 sm:h-4 sm:w-4 ml-1" data-id="element-20" />
                </span>
              </div>

              {/* Featured Image */}
              <ImageSection src="https://uploadthingy.s3.us-west-1.amazonaws.com/9vX9LnAAZUrcVNvUQgV8L6/pasted-image.png" alt="Woman measuring her leg with a measuring tape, struggling with lipedema" caption="Many women with lipedema struggle to find solutions that work" data-id="element-21" />

              {/* You're Not Alone */}
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-8 sm:mt-10 mb-3 sm:mb-4" data-id="element-22">
                You're Not Alone
              </h2>

              <p className="mb-4 sm:mb-6" data-id="element-23">
                You've been wearing compression stockings for your lipedema.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-24">
                And you're wondering why they don't work.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-25">You're not alone.</p>

              <p className="mb-4 sm:mb-6" data-id="element-26">
                Most women with lipedema feel the same way.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-27">
                {localizeText('New York')} specialists say traditional
                compression stockings fail for most women with lipedema.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-28">
                And there's a scientific reason why.
              </p>

              {/* But Most Articles Won't Tell You the Real Story */}
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-8 sm:mt-10 mb-3 sm:mb-4" data-id="element-29">
                But Most Articles Won't Tell You the Real Story
              </h2>

              <p className="mb-4 sm:mb-6" data-id="element-30">
                The worst part of lipedema isn't the swelling.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-31">It's what it does to your life.</p>

              <p className="mb-4 sm:mb-6" data-id="element-32">
                You skip dates. You're scared to wear a dress.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-33">
                You end relationships before they get serious. Before anyone
                sees you vulnerable.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-34">
                That voice in your head says: "No one could love me with legs
                like these."
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-35">
                Lipedema steals your confidence. Your social life. The feeling
                that you're attractive.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-36">
                And compression stockings make it worse.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-37">Think about it.</p>

              <p className="mb-4 sm:mb-6" data-id="element-38">
                Medical compression stockings scream "I have a problem." They're
                thick. Beige. Obviously medical.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-39">
                When you already feel self-conscious, wearing something that
                announces your condition is torture.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-40">So you're stuck.</p>

              <p className="mb-4 sm:mb-6" data-id="element-41">
                Wear compression and feel like a patient. Or skip it and deal
                with pain.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-42">
                But what if compression could work AND look normal?
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-43">
                What if it reduced swelling, felt good, and looked like regular
                leggings?
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-44">
                That's what women with lipedema want.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-45">
                And {localizeText('New York')} specialists say there's finally
                an answer.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-46">
                But first, you need to know why regular compression fails.
              </p>

              {/* What Doctors Say */}
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-8 sm:mt-10 mb-3 sm:mb-4" data-id="element-47">
                What Doctors Say
              </h2>

              <p className="mb-4 sm:mb-6" data-id="element-48">
                "We see women every single day who struggle with compression
                stockings," says Dr. Rachel Chen. She's a lymphatic specialist
                at the {localizeText('New York')} Center for Lymphatic Health.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-49">
                "They do everything their doctor tells them. They wear the
                stockings every day. And they still have swelling, pain, and
                frustration."
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-50">
                "The problem isn't the women," Dr. Chen says. "Compression
                stockings weren't made for lipedema."
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-51">
                And now, there's a better solution.
              </p>

              {/* The Truth About Compression Stockings */}
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-8 sm:mt-10 mb-3 sm:mb-4" data-id="element-52">
                The Truth About Compression Stockings
              </h2>

              <p className="mb-4 sm:mb-6" data-id="element-53">Let's be honest.</p>

              <p className="mb-4 sm:mb-6" data-id="element-54">
                Compression stockings are uncomfortable.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-55">
                They're hard to put on. They're hot. They dig into your skin.
                They leave marks.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-56">
                And if you have lipedema, they often make you feel worse.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-57">
                But you kept wearing them. Your doctor said they would help. You
                read online that compression reduces swelling. You thought maybe
                they'd start working if you just stuck with it.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-58">Sound familiar?</p>

              <p className="mb-4 sm:mb-6" data-id="element-59">
                Here's what most doctors don't tell you:
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-60">
                Compression stockings were made for varicose veins. For elderly
                patients with swelling.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-61">Not for lipedema.</p>

              <p className="mb-4 sm:mb-6" data-id="element-62">
                Lipedema is different. It has different fat patterns. Different
                lymphatic problems.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-63">This isn't a small detail.</p>

              <p className="mb-4 sm:mb-6" data-id="element-64">
                It's why compression stockings fail so many women with lipedema.
              </p>

              <ImageSection src="https://uploadthingy.s3.us-west-1.amazonaws.com/eCGcwekhgKdVToC7Uwq56x/ChatGPT_Image_11_%CE%9F%CE%BA%CF%84_2025%2C_04_40_54_%CE%BC.%CE%BC..png" alt="Uncomfortable compression marks from traditional stockings" caption="Traditional compression stockings often leave painful marks" width="3/4" data-id="element-65" />

              {/* The Three Problems */}
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-8 sm:mt-10 mb-3 sm:mb-4" data-id="element-66">
                The Three Problems with Traditional Compression
              </h2>

              <p className="mb-4 sm:mb-6" data-id="element-67">
                {localizeText('New York')} specialists found three big problems
                with traditional compression stockings:
              </p>

              <h3 className="text-lg font-bold text-gray-900 mt-6 sm:mt-8 mb-2" data-id="element-68">
                Problem #1: They Squeeze Everything the Same
              </h3>

              <p className="mb-4 sm:mb-6" data-id="element-69">
                Traditional compression stockings apply the same pressure from
                top to bottom.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-70">
                They squeeze your whole leg with the same force.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-71">
                But lipedema legs aren't the same all over.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-72">
                You have areas where fat builds up more. You have tender spots
                where pressure hurts. You have places where fluid pools.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-73">
                "It's like using one size fits all for a very personal
                condition," Dr. Chen says. "The areas that need support don't
                get it. The areas that need gentle treatment get squeezed too
                hard."
              </p>

              <ImageSection src="https://uploadthingy.s3.us-west-1.amazonaws.com/icymbux5wbm154SRSmarQe/ChatGPT_Image_11_%CE%9F%CE%BA%CF%84_2025%2C_04_40_55_%CE%BC.%CE%BC..png" alt="Diagram showing uniform pressure problem" caption="Traditional stockings apply the same pressure everywhere" width="2/3" data-id="element-74" />

              <h3 className="text-lg font-bold text-gray-900 mt-6 sm:mt-8 mb-2" data-id="element-75">
                Problem #2: They Don't Follow Your Lymphatic System
              </h3>

              <p className="mb-4 sm:mb-6" data-id="element-76">Here's the biggest issue.</p>

              <p className="mb-4 sm:mb-6" data-id="element-77">
                Your lymphatic system has specific paths for drainage.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-78">
                Fluid needs to move in one direction. Up and out of your legs.
                Back to your core. Following your body's natural routes.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-79">
                Traditional compression stockings don't follow these paths.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-80">
                They just squeeze everywhere the same. This can actually trap
                fluid instead of moving it.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-81">Think of it like this:</p>

              <p className="mb-4 sm:mb-6" data-id="element-82">
                Imagine trying to drain a bathtub by pushing water from the
                middle. Instead of letting it flow to the drain.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-83">
                You're working against your body instead of with it.
              </p>

              <ImageSection src="https://uploadthingy.s3.us-west-1.amazonaws.com/fJP5JtfucrJfsT1uk7QW3m/gempages_541671622348637232-7a3a123c-f1c8-4b25-b1a4-f051e570e74b_%283%29.webp" alt="Diagram of lymphatic pathways" caption="Good compression should follow your body's natural drainage paths" width="2/3" data-id="element-84" />

              <h3 className="text-lg font-bold text-gray-900 mt-6 sm:mt-8 mb-2" data-id="element-85">
                Problem #3: They Weren't Made for Lipedema
              </h3>

              <p className="mb-4 sm:mb-6" data-id="element-86">
                Traditional medical compression stockings were made decades ago.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-87">
                For varicose veins. For blood clots. For general leg swelling in
                elderly patients.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-88">Lipedema is different.</p>

              <p className="mb-4 sm:mb-6" data-id="element-89">
                It has different fat cells. Chronic inflammation. Different
                lymphatic drainage patterns.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-90">
                "You can't treat lipedema the same way you treat varicose
                veins," Dr. Chen says. "The biology is completely different.
                Women with lipedema need compression made for their condition."
              </p>

              {/* What Lipedema Actually Needs */}
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-8 sm:mt-10 mb-3 sm:mb-4" data-id="element-91">
                What Lipedema Actually Needs
              </h2>

              <p className="mb-4 sm:mb-6" data-id="element-92">
                So if traditional compression doesn't work, what does?
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-93">
                {localizeText('New York')} specialists say good compression for
                lipedema needs three things:
              </p>

              <h3 className="text-lg font-bold text-gray-900 mt-6 sm:mt-8 mb-2" data-id="element-94">
                1. Graduated Pressure
              </h3>

              <p className="mb-4 sm:mb-6" data-id="element-95">
                The compression should be strongest where fluid pools most.
                Usually the ankles.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-96">
                Then it should gradually get lighter as it moves up your leg.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-97">
                This creates a natural pressure slope. It encourages lymphatic
                drainage.
              </p>

              <h3 className="text-lg font-bold text-gray-900 mt-6 sm:mt-8 mb-2" data-id="element-98">
                2. Follows Lymphatic Paths
              </h3>

              <p className="mb-4 sm:mb-6" data-id="element-99">
                The compression needs to follow your body's natural drainage
                routes.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-100">
                It should gently guide trapped fluid along the right paths. Not
                just squeeze randomly.
              </p>

              <h3 className="text-lg font-bold text-gray-900 mt-6 sm:mt-8 mb-2" data-id="element-101">
                3. Made for Lipedema
              </h3>

              <p className="mb-4 sm:mb-6" data-id="element-102">
                The garment must work with lipedema's unique fat patterns. Its
                tender zones. The way it affects leg shape.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-103">
                Until recently, nothing like this existed.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-104">
                Women with lipedema had two bad choices:
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-105">
                Uncomfortable medical stockings that didn't work well. Or give
                up on compression entirely.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-106">But that's changed.</p>

              <ImageSection src="https://uploadthingy.s3.us-west-1.amazonaws.com/rLCAzcfebMhMNyKF4k1SA3/8.png" alt="Diagram showing graduated pressure zones in Elivara compression leggings" caption="Elivara uses graduated pressure zones: light at top, moderate in middle, high at ankles" data-id="element-107" />

              {/* The Compression Breakthrough */}
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-8 sm:mt-10 mb-3 sm:mb-4" data-id="element-108">
                The Compression Breakthrough Specialists Are Recommending
              </h2>

              <p className="mb-4 sm:mb-6" data-id="element-109">
                A company called Elivara made what {localizeText('New York')}{' '}
                specialists call the first real lipedema compression.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-110">
                It's nothing like traditional compression stockings.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-111">
                It's called FlowMapping™ Compression Technology.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-112">
                It fixes every problem that makes traditional compression fail.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-113">Here's how it works:</p>

              <p className="mb-4 sm:mb-6" data-id="element-114">
                Instead of the same pressure everywhere, Elivara uses graduated
                pressure zones.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-115">
                The pressure is strongest at your ankles. Where fluid pools
                most.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-116">
                Then it gradually gets lighter as it moves up your leg.
              </p>

              <ImageSection src="https://uploadthingy.s3.us-west-1.amazonaws.com/fvse8ULQVXf6Qnk6sWPrcM/pasted-image.png" alt="Comparison diagram showing traditional compression versus FlowMapping technology" caption="FlowMapping™ creates directional support that follows your lymphatic paths" data-id="element-117" />

              <p className="mb-4 sm:mb-6" data-id="element-118">
                This creates a gentle pressure slope.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-119">
                It naturally encourages trapped lymphatic fluid to move upward.
                To drain properly.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-120">
                Following your body's natural paths. Not fighting against them.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-121">
                But here's what really makes Elivara different:
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-122">
                They didn't just adapt existing compression for lipedema.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-123">
                They built it from scratch for women with this condition.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-124">That means:</p>

              <ul className="list-none pl-0 mb-4 sm:mb-6 space-y-2" data-id="element-125">
                <li className="flex items-start" data-id="element-126">
                  <span className="text-green-500 mr-2" data-id="element-127">✓</span>
                  <span data-id="element-128">
                    Pressure zones designed for lipedema's unique fat patterns
                  </span>
                </li>
                <li className="flex items-start" data-id="element-129">
                  <span className="text-green-500 mr-2" data-id="element-130">✓</span>
                  <span data-id="element-131">
                    Gentle compression in tender areas where traditional
                    stockings hurt
                  </span>
                </li>
                <li className="flex items-start" data-id="element-132">
                  <span className="text-green-500 mr-2" data-id="element-133">✓</span>
                  <span data-id="element-134">Extra support where lipedema fat builds up most</span>
                </li>
                <li className="flex items-start" data-id="element-135">
                  <span className="text-green-500 mr-2" data-id="element-136">✓</span>
                  <span data-id="element-137">Fabric that breathes and feels good all day</span>
                </li>
                <li className="flex items-start" data-id="element-138">
                  <span className="text-green-500 mr-2" data-id="element-139">✓</span>
                  <span data-id="element-140">Looks like regular leggings. Not medical devices.</span>
                </li>
              </ul>

              <p className="mb-4 sm:mb-6" data-id="element-141">
                "This is what compression for lipedema should have been all
                along," Dr. Chen says. She now recommends Elivara to her
                patients.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-142">
                "It's real support that follows the science of lymphatic
                drainage. Made specifically for how lipedema affects the body."
              </p>

              {/* What Women Are Saying */}
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-8 sm:mt-10 mb-3 sm:mb-6" data-id="element-143">
                What Women Are Saying
              </h2>

              <p className="mb-4 sm:mb-6" data-id="element-144">
                Women report very different results with Elivara compared to
                traditional compression stockings.
              </p>

              <div className="space-y-4 sm:space-y-6 mb-8 sm:mb-10" data-id="element-145">
                <Testimonial quote="I wore compression stockings for 8 months. Almost no improvement. I've been wearing Elivara for 3 weeks. The difference is incredible." author="Patricia G., 47, New York, NY" profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/g6rBRoysUyEVEFDJFiVEnE/istockphoto-1180524344-612x612_%281%29.jpg" data-id="element-146" />

                <Testimonial quote="I was so frustrated with compression stockings. They were impossible to put on. They hurt. They barely helped. I kept wearing them because my doctor said I should. But I dreaded it every day. Elivara is completely different. They feel like regular leggings. They don't hurt. My legs actually feel lighter by the end of the day. I can't believe I struggled with those stockings for so long." author="Sarah M., 41, Chicago, IL" profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/qw1Zck9T6xag8mmEh6bPti/mockup-pretty-curvy-latin-woman-600nw-2460705183_%281%29.webp" data-id="element-147" />

                <Testimonial quote="For the first time in years, I can wear compression without feeling like I'm suffocating my legs." author="Diana L., 52, Los Angeles, CA" profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/itD5PUebJe2STwyiveYzbu/istockphoto-1290775513-612x612_%281%29.jpg" data-id="element-148" />

                <Testimonial quote="Traditional compression stockings made me feel trapped. The pressure was so uncomfortable. Elivara's graduated compression feels completely different. It's supportive without being restrictive. And they look like normal leggings. I can actually wear them out of the house. I wear them every day now." author="Jennifer R., 38, Miami, FL" profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/kMiNm3v7qtTQa8SgVVQanP/Screenshot_2025-09-30_at_00.02.40.png" data-id="element-149" />

                <Testimonial quote="My swelling has gone down more in one month with Elivara than in six months with compression stockings." author="Nicole R., 39, Seattle, WA" profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/ktyrgyaucoXAJBEpygevN8/Screenshot_2025-09-30_at_00.02.43.png" data-id="element-150" />

                <Testimonial quote="I thought I was doing something wrong. My doctor kept telling me to wear compression stockings. But my legs were still swollen and painful every day. When I switched to Elivara, I finally understood what good compression feels like. The swelling has gone down a lot. The pain is less. And I actually want to wear them because they're comfortable." author="Rebecca T., 45, Denver, CO" profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/p82hupoTi6bS5hfqE4JSjZ/Beth_-_living_with_lipedema.webp" data-id="element-151" />

                <Testimonial quote="I can travel again without my legs ballooning up." author="Michelle K., 44, Austin, TX" profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/acEiFfQAqFoVbyHhX4St2Y/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_12_12_37_%CF%80.%CE%BC..png" data-id="element-152" />

                <Testimonial quote="Before Elivara, any long car ride or flight was torture. My legs would swell so badly I could barely walk afterward. Traditional compression stockings didn't help much. And they were so uncomfortable I couldn't stand wearing them for long trips. Now I wear my Elivara leggings whenever I travel. It's made such a difference. My legs stay comfortable even on long flights." author="Lisa B., 49, Phoenix, AZ" profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/58eTTAmUZvPANHSwRVq2PQ/ChatGPT_Image_11_%CE%9F%CE%BA%CF%84_2025%2C_05_02_29_%CE%BC.%CE%BC..png" data-id="element-153" />
              </div>

              {/* Why Elivara Works */}
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-8 sm:mt-10 mb-3 sm:mb-4" data-id="element-154">
                Why Elivara Works When Compression Stockings Don't
              </h2>

              <p className="mb-4 sm:mb-6" data-id="element-155">
                Let's compare traditional compression stockings to Elivara's
                FlowMapping™:
              </p>

              <ComparisonTable data-id="element-156" />

              <p className="mt-4 sm:mt-6 mb-4 sm:mb-6" data-id="element-157">
                The difference isn't small. It's huge.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-158">
                "Women tell me all the time they can't believe how different
                Elivara feels," Dr. Chen says.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-159">
                "That's because it's designed completely differently. It's not
                just marketing. It's an actual technological difference in how
                the compression works."
              </p>

              <ImageSection src="https://uploadthingy.s3.us-west-1.amazonaws.com/stpvy78Ka74JfhKzrApmz1/pasted-image.png" alt="Side-by-side comparison of woman without support showing discomfort versus woman with Elivara leggings showing comfort and support" caption="Elivara leggings provide all-day comfort, targeted support, and discreet style" data-id="element-160" />

              {/* Your Chance to Try */}
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-8 sm:mt-10 mb-3 sm:mb-4" data-id="element-161">
                Your Chance to Try Compression That Actually Works
              </h2>

              <p className="mb-4 sm:mb-6" data-id="element-162">Here's something important:</p>

              <p className="mb-4 sm:mb-6" data-id="element-163">
                Elivara uses specialized FlowMapping™ technology. It's made
                specifically for lipedema.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-164">
                They can only make limited quantities at a time.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-165">
                Right now, they're offering first-time customers 40% off.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-166">This isn't a permanent discount.</p>

              <p className="mb-4 sm:mb-6" data-id="element-167">
                It's designed to help women who've been frustrated with
                traditional compression. To help them access a solution that
                actually works. Without the high price that usually comes with
                specialized medical garments.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-168">But here's the reality:</p>

              <p className="mb-4 sm:mb-6" data-id="element-169">Elivara sells out regularly.</p>

              <p className="mb-4 sm:mb-6" data-id="element-170">
                When women with lipedema find compression that feels comfortable
                and provides real relief, word spreads fast.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-171">
                Popular sizes often disappear within days. Then you have to wait
                weeks for the next batch.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-172">
                If you've been struggling with compression stockings that don't
                work, this is your chance to try something completely different.
              </p>

              {/* You Weren't Doing It Wrong */}
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-8 sm:mt-10 mb-3 sm:mb-4" data-id="element-173">
                You Weren't Doing It Wrong
              </h2>

              <p className="mb-4 sm:mb-6" data-id="element-174">
                If you've spent months wearing compression stockings and feeling
                frustrated, I want you to hear this clearly:
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-175">You weren't doing it wrong.</p>

              <p className="mb-4 sm:mb-6" data-id="element-176">
                You were using the wrong type of compression for your condition.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-177">
                Compression stockings weren't made for lipedema.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-178">
                They were made for varicose veins. For general swelling in
                elderly patients.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-179">
                The fact that they didn't work well for you isn't your failure.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-180">It's a design flaw in the product.</p>

              <p className="mb-4 sm:mb-6" data-id="element-181">
                Now, for the first time, there's compression actually built for
                lipedema.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-182">
                Compression that follows your body's natural lymphatic paths.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-183">
                Compression that works with lipedema's unique fat patterns and
                tender zones.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-184">
                Compression that looks and feels like regular leggings. But
                delivers real relief.
              </p>

              {/* Imagine This */}
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-8 sm:mt-10 mb-3 sm:mb-4" data-id="element-185">
                Imagine This
              </h2>

              <p className="mb-4 sm:mb-6" data-id="element-186">
                Imagine putting on a pair of leggings in the morning.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-187">
                And feeling your legs get lighter throughout the day. Instead of
                heavier.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-188">
                Imagine compression that doesn't dig into your skin. Doesn't
                leave painful marks. Doesn't make you feel trapped.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-189">
                Imagine wearing something that provides real relief. Without
                announcing to the world that you're wearing a medical device.
              </p>

              <ImageSection src="https://uploadthingy.s3.us-west-1.amazonaws.com/fENsNgwMEFidRKe6A9GbhD/ChatGPT_Image_11_%CE%9F%CE%BA%CF%84_2025%2C_04_52_26_%CE%BC.%CE%BC..png" alt="Woman active and comfortable in Elivara leggings" caption="Elivara leggings let women with lipedema stay active and comfortable all day" data-id="element-190" />

              <p className="mb-4 sm:mb-6" data-id="element-191">That's what Elivara offers.</p>

              <p className="mb-4 sm:mb-6" data-id="element-192">
                And right now, you can try it at 40% off.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-193">
                Don't let another month go by struggling with compression that
                wasn't made for you.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-194">
                Try the compression that lipedema specialists are recommending.
              </p>

              <p className="mb-4 sm:mb-6" data-id="element-195">Before your size sells out.</p>

              <div className="flex justify-center my-8 sm:my-10" data-id="element-196">
                <CTAButton data-id="element-197" />
              </div>

              {/* Disclaimer */}
              <div className="text-xs text-gray-500 mt-8 sm:mt-10 mb-4 sm:mb-6 border-t border-gray-200 pt-4" data-id="element-198">
                <p className="mb-3 sm:mb-4" data-id="element-199">
                  This is an advertisement and not an actual news article, blog,
                  or consumer protection update. Individual results may vary.
                  The testimonials presented are from actual customers but may
                  not represent typical results.
                </p>
                <p className="mb-3 sm:mb-4" data-id="element-200">
                  About Us | Terms of Use | Privacy Policy
                </p>
                <p className="mb-3 sm:mb-4" data-id="element-201">
                  Trademarks utilized on our website belong to their respective
                  owners and no implied or expressed endorsement of our website
                  or services is intended. Through in-depth research and
                  experienced editors we provide feedback about products and
                  services. We are independently owned, and opinions expressed
                  here are our own. This website is an independent professional
                  comparison and review site supported by referral fees from the
                  sites and products featured.
                </p>
                <p data-id="element-202">©2025 Women's Health Insights. All Rights Reserved.</p>
              </div>
            </main>

            {/* CTA Section - Only visible on desktop */}
            <div className="hidden lg:block w-full lg:w-1/3 lg:sticky lg:top-8 self-start" data-id="element-203">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200" data-id="element-204">
                <div className="p-4" data-id="element-205">
                  <h3 className="text-center font-bold text-lg mb-4" data-id="element-206">
                    Instant Lipedema Relief or Money Back!
                  </h3>
                  <div className="mb-4" data-id="element-207">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3BFse8FnMG3SD5NNtv1DWX/pasted-image.png" alt="Elivara compression leggings with gradient compression technology" className="w-full rounded-md" data-id="element-208" />
                  </div>
                  <div className="flex items-center justify-center mb-2" data-id="element-209">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-210" />)}
                  </div>
                  <p className="text-center font-bold text-sm mb-1" data-id="element-211">
                    4.8 out of 5
                  </p>
                  <p className="text-center text-xs text-gray-600 mb-4" data-id="element-212">
                    3,791 customer ratings
                  </p>
                  <div className="space-y-1 mb-4" data-id="element-213">
                    <div className="flex items-center text-xs" data-id="element-214">
                      <span className="w-6 text-right mr-2" data-id="element-215">5★</span>
                      <div className="flex-grow h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-216">
                        <div className="h-full bg-yellow-400 w-[90%]" data-id="element-217"></div>
                      </div>
                      <span className="w-8 text-right ml-2" data-id="element-218">90%</span>
                    </div>
                    <div className="flex items-center text-xs" data-id="element-219">
                      <span className="w-6 text-right mr-2" data-id="element-220">4★</span>
                      <div className="flex-grow h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-221">
                        <div className="h-full bg-yellow-400 w-[7%]" data-id="element-222"></div>
                      </div>
                      <span className="w-8 text-right ml-2" data-id="element-223">7%</span>
                    </div>
                    <div className="flex items-center text-xs" data-id="element-224">
                      <span className="w-6 text-right mr-2" data-id="element-225">3★</span>
                      <div className="flex-grow h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-226">
                        <div className="h-full bg-yellow-400 w-[2%]" data-id="element-227"></div>
                      </div>
                      <span className="w-8 text-right ml-2" data-id="element-228">2%</span>
                    </div>
                    <div className="flex items-center text-xs" data-id="element-229">
                      <span className="w-6 text-right mr-2" data-id="element-230">2★</span>
                      <div className="flex-grow h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-231">
                        <div className="h-full bg-yellow-400 w-[0%]" data-id="element-232"></div>
                      </div>
                      <span className="w-8 text-right ml-2" data-id="element-233">0%</span>
                    </div>
                    <div className="flex items-center text-xs" data-id="element-234">
                      <span className="w-6 text-right mr-2" data-id="element-235">1★</span>
                      <div className="flex-grow h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-236">
                        <div className="h-full bg-yellow-400 w-[1%]" data-id="element-237"></div>
                      </div>
                      <span className="w-8 text-right ml-2" data-id="element-238">1%</span>
                    </div>
                  </div>
                  <button onClick={() => window.location.href = 'https://tryelivara.com/pages/elivara-landing-page'} className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-4 rounded flex items-center justify-center uppercase text-sm tracking-wider transition-colors duration-200" data-id="element-239">
                    CHECK AVAILABILITY{' '}
                    <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-240" />
                  </button>
                  <p className="text-center text-xs text-gray-600 mt-2" data-id="element-241">
                    Limited time offer - Fast FREE shipping across the US
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer data-id="element-242" />
      <StickyCTA data-id="element-243" />
    </div>;
};